import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {
    Row,
    Form,
    Icon,
    Input,
    Divider,
    Descriptions,
    Collapse,
    Select,
    InputNumber, Checkbox, Badge, Tag
} from 'antd';
import {RTLCol, RTLButton, RTLModal, RTLTable} from '../RTLKit';
import _ from 'lodash'

/* ------ Field -------- */
import TextArea from '../formFields/TextAreaField';
import DescriptionList from '../formFields/DescriptionList';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import Loading from "../loading/loading";
import moment from "jalali-moment";
import TextField from "../formFields/TextField";
import CheckBoxField from "../formFields/CheckBoxField";

class TechForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            orderId: this.props.match.params.orderId ? this.props.match.params.orderId : null,
            mode: '',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            formLayout: 'horizontal',
            guarantee_table:[],
            count:0,
            products:[],
            services:[],
            guarantee:false
        };
        this.props.setOrderId(this.state.orderId);

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        if (this.props.match.params.orderId){
            let orderId = this.props.match.params.orderId;
            this.props.getOrderItem(orderId)
        }
    }

    onChange = checkedList => {
        this.setState({
            guarantee_table : checkedList,
        });
    };

    onChangeCount(count,id,type){
        this.setState({
            count : count,
        });
        if(type === 'product') {
            let position = _.findIndex(this.state.products, {productId: id.toString()});
            if(count > 0) {
                if (position != -1) {
                    this.state.products.splice(position, 1, {
                        count: count,
                        productId: id,
                        guarantee: this.state.guarantee
                    });
                } else {
                    this.state.products.push({
                        count: count,
                        productId: id,
                        guarantee: false
                    })
                }
            }else{
                if (position != -1) {
                    this.state.products.splice(position, 1);
                }
            }
        }else if(type === 'service') {
            let position = _.findIndex(this.state.services, {serviceId: id.toString()});
            if(count > 0) {
                if (position != -1) {
                    this.state.services.splice(position, 1, {
                        count: count,
                        serviceId: id,
                        guarantee: this.state.guarantee
                    });
                } else {
                    this.state.services.push({
                        count: count,
                        serviceId: id,
                        guarantee: false
                    })
                }
            }else{
                if (position != -1) {
                    this.state.services.splice(position, 1);
                }
            }
        }
    };

    onChangeGuarantee(guarantee,id,type){
        this.setState({
            guarantee : guarantee,
        });

        if(type === 'product') {
            let position = _.findIndex(this.state.products, {productId: id.toString()});
            this.state.products.splice(position, 1, {count: this.state.count, productId: id, guarantee: true});
        }else if(type === 'service') {
            let position = _.findIndex(this.state.services, {serviceId: id.toString()});
            this.state.services.splice(position, 1, {count: this.state.count, serviceId: id, guarantee: true});
        }

    };

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        let date = '';
        let time = '';
        let fullName = '';
        let orderDescription = '';
        let orderType = '';
        let guaranteeLength = 0;
        let guaranteeList = [];
        const { Panel } = Collapse;
        const { Option } = Select;
        const { expandIconPosition } = this.state;

        if(this.props.initialValues) {
            this.props.getInvoiceItem(this.props.initialValues.order.customer_by._id)
            guaranteeList = this.props.invoiceInitialValues
            if(guaranteeList)
                guaranteeLength = guaranteeList.length
            orderType = (this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'خدمات');
            date = moment(this.props.initialValues.order.schedule_time).format('jYYYY/jM/jD')
            time = this.props.initialValues.order.schedule_hour
            this.props.initialValues.mode = this.state.mode
            this.props.initialValues.guarantee_table = this.state.guarantee_table
            this.props.initialValues.products = this.state.products
            this.props.initialValues.services = this.state.services
            fullName = this.props.initialValues.order.customer_by.name+' '+this.props.initialValues.order.customer_by.family
            if(this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY') {
                if(this.props.initialValues.order.product)
                    orderDescription = 'خرید دستگاه: ' + this.props.initialValues.order.product.title;
            }else{
                if(this.props.initialValues.order.fixtures)
                    for(let i=0 ; i<this.props.initialValues.order.fixtures.length ; i++){
                        orderDescription += this.props.initialValues.order.fixtures[i].title+' - ';
                    }
            }
        }
// console.log(guaranteeList)
        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">تکمیل فاکتور</Divider>
                </Row>

                {this.props.initialValues ?
                    <Row type="flex" justify="start" align="middle">
                        <RTLCol md={18} sm={24} type="flex" justify="start" align="middle">
                            <Row gutter={16}>
                                {this.props.initialValues && this.props.initialValues.order.guranatee_inquiry ?
                                    this.props.initialValues.order.guarantee_amount > 0 ?
                                        <div className={'invoice-services'}>
                                            استعلام این گارانتی تایید شده است و
                                            مبلغ {this.props.initialValues.order.guarantee_amount} ریال در هنگام تکمیل
                                            سفارش برای مشتری کسر خواهد شد
                                        </div>
                                    :
                                        this.props.initialValues.order.approved_guarantee === false && this.props.initialValues.order.has_checked_inquiry === false ?

                                            <div className={'invoice-services'}>
                                                برای این فاکتور استعلام گارانتی ارسال شده است و در حال بررسی میباشد
                                            </div>
                                        :
                                            <div className={'border-green'}>
                                                استعلام گارانتی رد شد
                                            </div>

                                :
                                    <div>
                                        {guaranteeList && guaranteeList.length > 0 ?
                                            <Collapse expandIconPosition={"left"} className={'collapse-box'}
                                                      expandIcon={({isActive}) => <Icon type="up"
                                                                                        rotate={isActive ? 180 : 0}/>}>
                                                <Panel className={'collapse-header'} header={`این مشتری دارای ${guaranteeLength} محصول گارانتی دارد`} key="1">
                                                    <Checkbox.Group style={{ width: '100%' }} onChange={this.onChange}>
                                                        {guaranteeList && guaranteeList.length > 0 && guaranteeList.map((item, index) => {
                                                            let currentTime = parseInt(new Date().getTime()/1000)
                                                            let finishTime = parseInt(new Date(item.guarantee_finish_date).getTime()/1000)
                                                            return (
                                                                <div className={'invoice-services'} key={index}>
                                                                    <div style={{marginLeft:10}} className={'right'}>
                                                                        {currentTime <= finishTime ?
                                                                            <Checkbox value={item._id}></Checkbox>
                                                                            :
                                                                            <Tag color="magenta">تاریخ گارانتی به اتمام رسیده است</Tag>
                                                                        }
                                                                    </div>
                                                                    <div className={'right'}>
                                                                        <div>شماره گارانتی : {item.system_code}</div>
                                                                        <div>{item.title}</div>
                                                                        <div>تاریخ اتمام گارانتی : {moment(item.guarantee_finish_date).format('jYYYY/jM/jD')}</div>
                                                                        <div>تعداد دفعات استفاده : {item.used_count}</div>
                                                                    </div>
                                                                    <div className={'clearfix'}></div>
                                                                </div>
                                                            )
                                                        })}
                                                    </Checkbox.Group>
                                                </Panel>
                                            </Collapse>
                                        :
                                            <div className={'border-green'}>
                                                این مشتری دارای گارانتی معتبر نمیباشد
                                            </div>
                                        }
                                    </div>
                                }
                            </Row>
                            <Row gutter={16}>
                                <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                              layout="vertical">
                                    <Descriptions.Item label="شماره درخواست">
                                        {this.props.initialValues ? this.props.initialValues.order.system_code : ''}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="نوع خدمت">{orderType}</Descriptions.Item>
                                    <Descriptions.Item label={`تاریخ:${date}`}>{`ساعت:${time}`}</Descriptions.Item>
                                </Descriptions>

                                <Descriptions className={'invoice-description'} colon={false} size={'small'}
                                              layout="vertical">
                                    <Descriptions.Item label={fullName}>
                                        {this.props.initialValues ? this.props.initialValues.order.customer_by.mobile : ''}
                                    </Descriptions.Item>
                                    <Descriptions.Item>
                                        {orderDescription}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">انتخاب دستگاه</Divider>

                                <Collapse expandIconPosition={"left"} className={'collapse-box'}
                                          expandIcon={({isActive}) => <Icon type="up" rotate={isActive ? 180 : 0}/>}>
                                    {this.props.initialValues && this.props.initialValues.products_tree.length > 0 && this.props.initialValues.products_tree.map((item, index) => {
                                        return (
                                            <Panel className={'collapse-header'} header={item.title} key={index}>
                                                {item && item.products.length > 0 && item.products.map((product, index) => {
                                                    if (product.total_amount > 0) {
                                                        return (
                                                            <div className={'collapse-text'} key={index}>
                                                                <div className={'invoice-services'}>
                                                                    <RTLCol className={'right'}>
                                                                        <div>{product.title}</div>
                                                                        <div>{product.price} ریال</div>
                                                                    </RTLCol>
                                                                    <RTLCol className={'left'}>
                                                                        <div>
                                                                            <InputNumber name={'count'} size="small"
                                                                                         min={0}
                                                                                         max={product.total_amount}
                                                                                         onChange={(count) => this.onChangeCount(count, product._id, 'product')}
                                                                                         defaultValue={0}/>
                                                                        </div>
                                                                        {(this.props.initialValues &&
                                                                            this.props.initialValues.order.guranatee_inquiry &&
                                                                            this.props.initialValues.order.guarantee_amount > 0) ||
                                                                        (guaranteeList && guaranteeList.length === 0) ? null :
                                                                            <div>
                                                                                <div className={'right'} style={{paddingTop:7}}>استعلام گارانتی</div>
                                                                                <div className={'right'}>
                                                                                    <Field
                                                                                        name="guarantee"
                                                                                        component={CheckBoxField}
                                                                                        list={[{label : '' , value : true}]}
                                                                                        onChange={(guarantee) => this.onChangeGuarantee(guarantee[0],product._id,'product')}/>
                                                                                </div>
                                                                                <div className={'clearfix'}></div>
                                                                            </div>
                                                                        }
                                                                    </RTLCol>
                                                                    <div className={'clearfix'}></div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </Panel>
                                        )
                                    })}
                                </Collapse>

                                <Collapse expandIconPosition={"left"} className={'collapse-box'}
                                          expandIcon={({isActive}) => <Icon type="up" rotate={isActive ? 180 : 0}/>}>
                                    <Panel className={'collapse-header'} header="سرویس های انجام شده" key="1">
                                        {this.props.initialValues && this.props.initialValues.service_types.length > 0 && this.props.initialValues.service_types.map((item, index) => {
                                            return (
                                                <div className={'invoice-services'} key={index}>
                                                    <RTLCol className={'right'}>
                                                        <div>{item.title}</div>
                                                        <div>{item.price} ریال</div>
                                                    </RTLCol>
                                                    <RTLCol className={'left'}>
                                                        <div>
                                                            <InputNumber size="small" min={0} max={20}
                                                                         defaultValue={0}
                                                                         onChange={(count) => this.onChangeCount(count, item._id, 'service')}
                                                            />

                                                        </div>
                                                        {(this.props.initialValues &&
                                                            this.props.initialValues.order.guranatee_inquiry &&
                                                            this.props.initialValues.order.guarantee_amount > 0) ||
                                                        (guaranteeList && guaranteeList.length === 0) ? null :
                                                            <div>
                                                                <div className={'right'} style={{paddingTop:7}}>استعلام گارانتی</div>
                                                                <div className={'right'}>
                                                                    <Field
                                                                        name="guarantee"
                                                                        component={CheckBoxField}
                                                                        list={[{label : '' , value : true}]}
                                                                        onChange={(guarantee) => this.onChangeGuarantee(guarantee[0],item._id,'service')}/>
                                                                </div>
                                                                <div className={'clearfix'}></div>
                                                            </div>
                                                        }
                                                    </RTLCol>
                                                    <div className={'clearfix'}></div>
                                                </div>
                                            )
                                        })}
                                    </Panel>
                                </Collapse>
                                {(this.props.initialValues &&
                                    this.props.initialValues.order.guranatee_inquiry &&
                                    this.props.initialValues.order.guarantee_amount > 0) ||
                                    (guaranteeList && guaranteeList.length === 0) ? null :
                                    <div>
                                        <Divider orientation="left">توضیحات</Divider>

                                        <Field
                                            name="technician_description"
                                            component={TextField}
                                            type="text"
                                            placeholder="توضیحات تکنسین"
                                        />
                                    </div>
                                }

                            </Row>
                            <Row>
                                <RTLButton loading={this.props.common.isProgressing} type="primary" shape="round"
                                   disabled = {(this.props.initialValues &&
                                   this.props.initialValues.order.guranatee_inquiry &&
                                   this.props.initialValues.order.guarantee_amount > 0) || (guaranteeList && guaranteeList.length === 0) ?
                                       true : false
                                   }
                                   htmlType="submit" className="login-form-button" onClick={()=>this.setState({mode:'guarantee'})}>

                                ارسال استعلام
                                </RTLButton>
                                <RTLButton loading={this.props.common.isProgressing} shape="round"
                                   disabled = {this.props.initialValues &&
                                   this.props.initialValues.order.guranatee_inquiry &&
                                   this.props.initialValues.order.has_checked_inquiry === false ?
                                       true : false
                                   }
                                   htmlType="submit" className="backBtn" type="default" onClick={()=>this.setState({mode:'add'})}>
                                    ارسال به مشتری
                                </RTLButton>
                            </Row>
                        </RTLCol>
                    </Row>
                :
                    <Loading list={this.props.initialValues}/>
                }
            </Form>

        );
    }

}

export default TechForm = reduxForm({
    form: 'order',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(TechForm)
